// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
var inject = allVue.inject;
import { getNestedValue, parsers } from '../utils/main';
import { provideIntlService } from '@progress/kendo-vue-intl';
import { getTemplate, noop } from '@progress/kendo-vue-common';
import { KEYBOARD_NAV_DATA_ID, KEYBOARD_NAV_DATA_LEVEL } from '@progress/kendo-vue-data-tools';
/**
 * @hidden
 */
var GridCellVue2 = {
  name: 'GridCell',
  inheritAttrs: false,
  // @ts-ignore
  emits: {
    cellclick: null,
    cellkeydown: null
  },
  props: {
    id: String,
    field: String,
    dataItem: Object,
    format: String,
    readFormat: String,
    className: String,
    colSpan: Number,
    columnIndex: Number,
    columnsCount: Number,
    dataIndex: Number,
    rowType: String,
    level: Number,
    expanded: Boolean,
    type: String,
    editor: String,
    isSelected: Boolean,
    ariaColumnIndex: Number,
    render: [String, Function, Object]
  },
  inject: {
    kendoIntlService: {
      default: null
    },
    getKeyboardNavigationAttributes: {
      default: noop
    }
  },
  methods: {
    triggerClick: function triggerClick() {
      this.$emit('cellclick', {
        dataItem: this.$props.dataItem,
        field: this.$props.field
      });
    },
    triggerKeydown: function triggerKeydown(e) {
      this.$emit('cellkeydown', {
        event: e,
        dataItem: this.$props.dataItem,
        field: this.$props.field
      });
    },
    triggerEdit: function triggerEdit(dataItem) {
      this.$emit('edit', dataItem);
    },
    triggerAdd: function triggerAdd(dataItem) {
      this.$emit('add', dataItem);
    },
    triggerCancel: function triggerCancel(dataItem) {
      this.$emit('cancel', dataItem);
    },
    triggerSave: function triggerSave(dataItem) {
      this.$emit('save', dataItem);
    },
    triggerRemove: function triggerRemove(dataItem) {
      this.$emit('remove', dataItem);
    }
  },
  created: function created() {
    this._intl = provideIntlService(this);
  },
  computed: {
    tdClass: function tdClass() {
      var _a;
      var className = this.$props.className;
      return _a = {
        'k-table-td': true
      }, _a[className] = className, _a;
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    var kendoIntlService = inject('kendoIntlService', {});
    return {
      v3: v3,
      kendoIntlService: kendoIntlService
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var defaultRendering = null;
    var navAttrs = this.getKeyboardNavigationAttributes(this.$props.id);
    if (this.$props.rowType === 'groupFooter') {
      defaultRendering = h("td", {
        "class": this.tdClass
      });
    } else if (this.$props.field !== undefined && this.$props.rowType !== 'groupHeader') {
      var data = getNestedValue(this.$props.field, this.$props.dataItem);
      var dataAsString = '';
      if (data !== undefined && data !== null) {
        dataAsString = this.$props.format ? this.$props.type ? this._intl.format(this.$props.format, parsers[this.$props.type](data, this._intl, this.$props.readFormat)) : this._intl.format(this.$props.format, data) : data.toString();
      }
      defaultRendering = h("td", {
        style: this.$attrs.style,
        colspan: this.$props.colSpan,
        attrs: this.v3 ? undefined : {
          colspan: this.$props.colSpan,
          role: 'gridcell',
          "aria-colindex": this.$props.ariaColumnIndex,
          "aria-selected": this.$props.isSelected,
          "data-grid-col-index": this.$props.columnIndex,
          tabindex: navAttrs.tabIndex,
          "data-keyboardnavlevel": navAttrs[KEYBOARD_NAV_DATA_LEVEL],
          "data-keyboardnavid": navAttrs[KEYBOARD_NAV_DATA_ID]
        },
        "class": this.tdClass,
        onKeydown: this.triggerKeydown,
        on: this.v3 ? undefined : {
          "keydown": this.triggerKeydown,
          "click": this.triggerClick
        },
        onClick: this.triggerClick,
        role: 'gridcell',
        "aria-colindex": this.$props.ariaColumnIndex,
        "aria-selected": this.$props.isSelected,
        "data-grid-col-index": this.$props.columnIndex,
        tabindex: navAttrs.tabIndex,
        "data-keyboardnavlevel": navAttrs[KEYBOARD_NAV_DATA_LEVEL],
        "data-keyboardnavid": navAttrs[KEYBOARD_NAV_DATA_ID]
      }, [dataAsString]);
    }
    return getTemplate.call(this, {
      h: h,
      template: this.$props.render,
      defaultRendering: defaultRendering,
      additionalProps: this.$props,
      additionalListeners: {
        click: this.triggerClick,
        keydown: this.triggerKeydown,
        edit: this.triggerEdit,
        add: this.triggerAdd,
        cancel: this.triggerCancel,
        save: this.triggerSave,
        remove: this.triggerRemove
      }
    });
  }
};
/**
 * @hidden
 */
var GridCell = GridCellVue2;
export { GridCell, GridCellVue2 };